import { createContext } from '@/utils';
import type { CurrentUserContextValue } from './types';

export const CurrentUserContext = createContext<CurrentUserContextValue>(
  undefined,
  'CurrentUserContext'
);
